module.exports = "/virtual-football-league/img/amblems/left/logos/Sev.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Sev.png
// module id = 2124
// module chunks = 4